import type { FC } from 'react'

import { RUBLE } from '@/helpers/consts'
import { Button, Drawer, Heading } from '@/components'
import { useBecomeShareholderStore } from '../store'
import bgStep1Svg from './img/bg-step1.png'
import step1Svg from './img/step1.svg'
import step2Svg from './img/step2.svg'
import step3Svg from './img/step3.svg'
import {
  SC_Step,
  SC_StepsWrapper,
  SC_VertLine,
} from './styled'


export const BecomeShareholderStep1Drawer: FC = () => {
  const hideBecomeShareholderStep1Drawer = useBecomeShareholderStore((s) => s.hideBecomeShareholderStep1Drawer)
  const showBecomeShareholderStep2Drawer = useBecomeShareholderStore((s) => s.showBecomeShareholderStep2Drawer)


  return (
    <Drawer
      isBackdropClosable
      onClose={hideBecomeShareholderStep1Drawer}
    >
      <Heading level={2} centered>
        Новые возможности для пайщиков
      </Heading>

      <p style={{ marginBottom: '11px', textAlign: 'center', marginTop: '8px' }}>
        Пайщик получает карту, кэшбэк на повседневные покупки и доход без ИП, ООО и самозанятости
      </p>

      <img src={bgStep1Svg} style={{ marginBottom: '16px', width: '100%' }} alt='' />

      <Heading level={3}>
        Что нужно сделать?
      </Heading>

      <SC_StepsWrapper>
        <SC_Step>
          <div><img src={step1Svg} alt='' /></div>
          <span>Заполните свои личные данные для оформления заявления</span>
        </SC_Step>

        <SC_VertLine />

        <SC_Step>
          <div><img src={step2Svg} alt='' /></div>
          <span>Далее с вашего счёта автоматически спишется вступительный взнос 100 {RUBLE}</span>
        </SC_Step>

        <SC_VertLine />

        <SC_Step>
          <div><img src={step3Svg} alt='' /></div>

          <span>
            После оплаты откроется полный функционал пайщика
          </span>
        </SC_Step>
      </SC_StepsWrapper>

      <div style={{ display: 'block', marginBottom: '19px', whiteSpace: 'normal' }}>
        Важно: Если на счёте недостаточно средств, списание не произойдёт, 
        и доступ к функционалу будет временно ограничен до момента оплаты.
      </div>

      <Button
        $isVeryRadiused
        $extraSize='veryLarge'
        $isBlack
        block
        onClick={() => {
          hideBecomeShareholderStep1Drawer()
          showBecomeShareholderStep2Drawer()
        }}
      >
        Далее
      </Button>
    </Drawer>
  )
}
